import type { OnError } from '@johnlewispartnership/wtr-content-component-library/dist/component-library/config/types';

import { getApm } from 'shared/apm';

export const onError: OnError = async (error, additionalData) => {
  const apm = await getApm('error-only');

  if (apm?.captureError) {
    apm.captureError(Object.assign(error, additionalData));
    return;
  }

  console.error('APM is not available on the window.', error);
};
